
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38 29.5v7a1.496 1.496 0 01-1.5 1.5h-7c-1.337 0-2.006-1.619-1.063-2.563l2.263-2.262-6.7-6.7-6.702 6.706 2.265 2.256c.943.944.274 2.563-1.063 2.563h-7a1.496 1.496 0 01-1.5-1.5v-7c0-1.338 1.618-2.006 2.563-1.063l2.261 2.263L21.53 24l-6.705-6.706-2.261 2.269c-.944.943-2.563.275-2.563-1.063v-7a1.496 1.496 0 011.5-1.5h7c1.337 0 2.006 1.619 1.063 2.563L17.3 14.825l6.7 6.7 6.702-6.706-2.265-2.256C27.494 11.619 28.163 10 29.5 10h7a1.496 1.496 0 011.5 1.5v7c0 1.338-1.618 2.006-2.563 1.063L33.176 17.3 26.47 24l6.705 6.706 2.261-2.262c.944-.95 2.563-.282 2.563 1.056z","fill":"#535353"}})])
          )
        }
      }
    